import cc from 'classcat';
import PropTypes from 'prop-types';

import css from './index.module.scss';
import Image from '../Image';

const getSeperator = (total, idx) => {
  if (idx === 0) {
    return '';
  }

  if (total === 2) {
    return ' and ';
  }

  if (idx === total - 1) {
    return ', and ';
  }

  return ', ';
};

const sponsorPropType = {
  idx: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  total: PropTypes.number.isRequired,
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

const Sponsor = ({ url, name, total, idx }) => (
  <>
    {getSeperator(total, idx)}
    {url && (
      <a href={url} target="_blank" rel="noreferrer noopener">
        {name}
      </a>
    )}
    {!url && name}
  </>
);
Sponsor.defaultProps = {
  url: false,
};
Sponsor.propTypes = sponsorPropType;

const List = ({ sponsors }) => (
  <div className={css.root}>
    <h5 className={css.title}>Event Sponsored by:</h5>
    <div className={css.list}>
      {sponsors.map((sponsor, idx) => (
        <Sponsor key={sponsor.id} total={sponsors.length} idx={idx} {...sponsor} />
      ))}
    </div>
  </div>
);
List.propTypes = {
  sponsors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
    }),
  ).isRequired,
};

const ListWithImages = ({ sponsors }) => (
  <div className={css.root}>
    <h5 className={cc([css.title, css.large])}>Sponsors & Partners</h5>
    <div className={css.images}>
      {sponsors.map((sponsor) => (
        <div className={css.image} key={sponsor.id}>
          <a href={sponsor.url} rel="noreferrer noopener" target="_blank">
            <Image {...sponsor.image} />
          </a>
        </div>
      ))}
    </div>
  </div>
);
ListWithImages.propTypes = {
  sponsors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
    }),
  ).isRequired,
};

const Sponsors = ({ sponsors }) => {
  const sponsorsWithImages = sponsors.filter((sponsor) => sponsor.image !== null);
  const sponsorsWithoutImages = sponsors.filter((sponsor) => sponsor.image === null);
  return (
    <>
      {sponsorsWithImages.length > 0 && <ListWithImages sponsors={sponsorsWithImages} />}
      {sponsorsWithoutImages.length > 0 && <List sponsors={sponsorsWithoutImages} />}
    </>
  );
};

Sponsors.propTypes = {
  sponsors: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
      image: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
    }),
  ).isRequired,
};

export default Sponsors;
